<template>
    <div>
        <h4 class="text-primary">Configuration générale</h4>
        <hr>
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-home-tab" data-toggle="tab" data-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Villes</button>
                <button class="nav-link" id="nav-profile-tab" data-toggle="tab" data-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Type de marchandise</button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <IndexVille></IndexVille>
            </div>
            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                <IndexService></IndexService>
            </div>
        </div>
    </div>
</template>

<script>
import IndexVille from "./villes/IndexVille.vue";
import IndexService from "./types_marchandises/IndexTypeMarchandise.vue";
export default {
    components: { IndexVille, IndexService }
}
</script>